"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const svgIcons_1 = require("../../../svgIcons");
const core_1 = require("@material-ui/core");
require("./style.scss");
const NoSearchResult = () => {
    return (react_1.default.createElement(core_1.Box, { display: "block", textAlign: "center", className: 'no-search-result' },
        react_1.default.createElement(svgIcons_1.NoSearchResultIcon, null),
        react_1.default.createElement("p", { className: 'text' }, "No results found.")));
};
exports.default = NoSearchResult;
